import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);

export const useTheme = () => {
  return useContext(ThemeContext);
};

const THEME_LINK_ID = "theme-stylesheet";
const THEME_URL = `${process.env.PUBLIC_URL}/themes/lara-light-blue/theme.css`;

export const GRADIENT_PRESETS = [
  { id: "emerald",  label: "Emerald",  gradient: "linear-gradient(135deg, #1a9a7a, #7dce82)" },
  { id: "ocean",    label: "Ocean",    gradient: "linear-gradient(135deg, #2b7cd8, #6ec3f0)" },
  { id: "purple",   label: "Purple",   gradient: "linear-gradient(135deg, #7c5cbf, #b89de0)" },
  { id: "sunset",   label: "Sunset",   gradient: "linear-gradient(135deg, #e08b50, #f0c47a)" },
  { id: "teal",     label: "Teal",     gradient: "linear-gradient(135deg, #1a9e92, #6dd4c8)" },
  { id: "indigo",   label: "Indigo",   gradient: "linear-gradient(135deg, #5a6abf, #a48dd4)" },
  { id: "steel",    label: "Steel",    gradient: "linear-gradient(135deg, #546878, #94a3b0)" },
  { id: "rose",     label: "Rose",     gradient: "linear-gradient(135deg, #c45a6a, #e8a0aa)" },
  { id: "mint",     label: "Mint",     gradient: "linear-gradient(135deg, #3a9e8f, #8fd4c8)" },
];

export const ThemeProvider = ({ children }) => {
  const [accentId, setAccentId] = useState(() => {
    return localStorage.getItem("accent") || "emerald";
  });
  const [loaded, setLoaded] = useState(false);

  const setAccent = (id) => {
    setAccentId(id);
    localStorage.setItem("accent", id);
  };

  const accent = GRADIENT_PRESETS.find((p) => p.id === accentId) || GRADIENT_PRESETS[0];

  useEffect(() => {
    const existingLink = document.getElementById(THEME_LINK_ID);
    if (existingLink) {
      existingLink.remove();
    }

    const link = document.createElement("link");
    link.id = THEME_LINK_ID;
    link.rel = "stylesheet";
    link.href = THEME_URL;
    link.onload = () => setLoaded(true);

    document.head.insertBefore(link, document.head.firstChild);

    return () => {
      const linkToRemove = document.getElementById(THEME_LINK_ID);
      if (linkToRemove) {
        linkToRemove.remove();
      }
    };
  }, []);

  const value = {
    theme: 'light-blue',
    isDark: false,
    accent,
    accentId,
    setAccent,
    loaded,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
